import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "./Industries.css";

const PrevArrow = ({ onClick }) => (
  <button className="ind-arrow ind-prev" onClick={onClick}>
    <i className="bi bi-arrow-left"></i>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="ind-arrow ind-next" onClick={onClick}>
    <i className="bi bi-arrow-right"></i>
  </button>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 700,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 576, settings: { slidesToShow: 1 } },
  ],
};

export default function Industries() {
  const sliderRef = useRef(null);
  const [industriesData, setIndustriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setIndustriesData(data.industries);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <section className="industries-section">
      <div className="container">

        {/* HEADER */}
        <div className="ind-header">
          <div className="ind-top">
            <span className="ind-tag">Explore</span>
            <h2>Industry experience that shapes practical solutions</h2>

          </div>
          <a href="#contact" className="ind-btn">
            View all
          </a>
        </div>

        {/* SLIDER */}
        <div className="ind-slider-wrap">
          <Slider {...settings} ref={sliderRef}>
            {industriesData.map((item) => (
              <div key={item.id} className="ind-slide">
                <div className="ind-card">
                  <div className="ind-card-pic">
                    <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${item.folder_path}/${item.image}`} alt={item.title} />

                    {/* Hover Overlay — visible on hover via CSS */}
                    <div className="ind-overlay">
                      <div className="overlay-content">
                        <div className="circle">
                          <i className="bi bi-arrow-right"></i>
                        </div>
                        <h4>{item.name}</h4>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Card — fades out on hover */}
                  <div className="ind-info">
                    <h4>{item.name}</h4>
                    <span></span>
                    <p>{item.short_description}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </section>
  );
}